import React , {useState} from 'react';
import { useDispatch } from 'react-redux';
import { openDeleteStateModal, openEditStateModal } from '../../Store/Slices/stateSlice';
import { PaginationDetails } from '../../Utils/Utils';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Pagination , Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from './CouponList.module.css';
import usePagination from '../../Hooks/usePagination';




const CouponList = ({ data }) => {
    const dispatch = useDispatch();
    const { page, count, handleChange, _DATA } = PaginationDetails(data);


    const handleEdit = (stateId) => {
        dispatch(openEditStateModal(stateId));
    };

    const handleDelete = (stateId) => {
        dispatch(openDeleteStateModal(stateId));
    };

    const currentData = _DATA?.currentData() || data;

    const roles = sessionStorage.getItem("roles");

    return (
        <>
            <TableContainer sx={{ height: "43rem" }}>
                <Table  sx={{borderCollapse:'separate' , borderSpacing:'0px 4px' , height:'max-content'}} stickyHeader>
                    <TableHead  >
                        <TableRow >
                            <TableCell width={50}>State Id</TableCell>
                            <TableCell width={50}>State</TableCell>
                            <TableCell align="center" width={"30%"}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody >
                        {currentData.map((state) => (
                            <TableRow sx={{ height: "30px" }} key={state.stateId}>
                                <TableCell  component='th' scope='row' sx={{ borderBottom: "none", fontWeight: 'bold', width: 100, height: 'auto !important' }}>#{state.stateId}</TableCell>
                                <TableCell sx={{ borderBottom: "none", width: 150, height: 'auto !important' }}>{state.state}</TableCell>
                                <TableCell align="center" sx={{ borderBottom: "none", width: '15%', height: 'auto !important' }}>
                                    {roles?.split(",").includes("PRIV_ES_EDIT_STATE") ?  (<IconButton onClick={() => handleEdit(state.stateId)}>
                                        <EditIcon />
                                    </IconButton>) : null}
                                    {roles?.split(",").includes("PRIV_ES_DELETE_STATE") ?  (<IconButton onClick={() => handleDelete(state.stateId)}>
                                        <DeleteIcon />
                                    </IconButton>) : null}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            
            </TableContainer>
            <Box my={2} display="flex" justifyContent="center">
                <Pagination
                    count={count}
                    page={page}
                    onChange={handleChange}
                    color="primary"
                    size='large'
                    variant = 'outlined'
                />
            </Box>
                
        
          
        </>
    );
};

export default CouponList;
